import { useState } from 'react';
import { SpinLoadingContext } from './SpinLoadingContext';

export const SpinLoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return <SpinLoadingContext.Provider value={{ loading, setLoading }}>{children}</SpinLoadingContext.Provider>;
};
